module.exports = __webpack_public_path__ + "static/media/The Interview.2c827155.pdf";